import { configServices } from 'src/services';
import { hideLoadingModalReducer, setAlertResponse, showLoadingModalReducer } from 'src/store';
import { useDispatch } from 'react-redux';
import { useGetConfig, useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';

export const HTHConfig = () => {
    const config = useGetConfig();
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();
    //
    const rowStyles = { marginTop: '14px', width: isMobile ? '400px' : '800px' };

    const setDisableEditHthMapsHandler = async () => {
        dispatch(showLoadingModalReducer());
        const response = await configServices.SetDisableEditMaps(!config.isDisabledEditHthMaps);
        dispatch(hideLoadingModalReducer());
        if (!response.success) {
            dispatch(setAlertResponse({ response }));
            return;
        }
        window.location.reload();
    }

    const setDisableHthFaceObservatiosHandler = async () => {
        dispatch(showLoadingModalReducer());
        const response = await configServices.SetDisableHthFaceObservatios(!config.isDisabledHthFaceObservations);
        dispatch(hideLoadingModalReducer());
        if (!response.success) {
            dispatch(setAlertResponse({ response }));
            return;
        }
        window.location.reload();
    }

    const setUsingLettesForBlocksHandler = async () => {
        dispatch(showLoadingModalReducer());
        const response = await configServices.SetUsingLettersForBlocks(!config.isUsingLettersForBlocks);
        dispatch(hideLoadingModalReducer());
        if (!response.success) {
            dispatch(setAlertResponse({ response }));
            return;
        }
        window.location.reload();
    }

    const setIsEnabledHthDoubleStateHandler = async () => {
        dispatch(showLoadingModalReducer());
        const response = await configServices.SetIsEnabledHthDoubleState(!config.isEnabledHthDoubleState);
        dispatch(hideLoadingModalReducer());
        if (!response.success) {
            dispatch(setAlertResponse({ response }));
            return;
        }
        window.location.reload();
    }

    const setIsSharingAllHandler = async () => {
        dispatch(showLoadingModalReducer());
        const response = await configServices.SetHthIsSharingAll(!config.isSharingHthAll);
        dispatch(hideLoadingModalReducer());
        if (!response.success) {
            dispatch(setAlertResponse({ response }));
            return;
        }
        window.location.reload();
    }

    return (
        <div className={`container card ${isDarkMode ? 'bg-dark text-white' : ''} py-2 pb-3 mt-5`}>
            <div className={'d-flex row justify-content-center align-items-center'} style={rowStyles}>
                <div className={`${isMobile ? 'col-2' : 'col-3'} text-end`}>
                    <input type='checkbox'
                        className={'form-check-input checkbox-md pointer'}
                        checked={!config.isDisabledEditHthMaps}
                        onChange={setDisableEditHthMapsHandler}
                    />
                </div>
                <div className={'col'}>
                    <h5 className={`${isDarkMode ? 'text-white' : ''} pt-2`}>
                        Habilitar edición de Mapas
                    </h5>
                </div>
            </div>
            <div className={'d-flex row justify-content-center align-items-center'} style={rowStyles}>
                <div className={`${isMobile ? 'col-2' : 'col-3'} text-end`}>
                    <input type='checkbox'
                        className={'form-check-input checkbox-md pointer'}
                        checked={!config.isDisabledHthFaceObservations}
                        onChange={setDisableHthFaceObservatiosHandler}
                    />
                </div>
                <div className={'col'}>
                    <h5 className={`${isDarkMode ? 'text-white' : ''} pt-2`}>
                        Habilitar función de Observaciones de Caras
                    </h5>
                </div>
            </div>
            <div className={'d-flex row justify-content-center align-items-center'} style={rowStyles}>
                <div className={`${isMobile ? 'col-2' : 'col-3'} text-end`}>
                    <input type='checkbox'
                        className={'form-check-input checkbox-md pointer'}
                        checked={!!config.isUsingLettersForBlocks}
                        onChange={setUsingLettesForBlocksHandler}
                    />
                </div>
                <div className={'col'}>
                    <h5 className={`${isDarkMode ? 'text-white' : ''} pt-2`}>
                        Usar letras para identificar las manzanas en vez de números
                    </h5>
                </div>
            </div>
            <div className={'d-flex row justify-content-center align-items-center'} style={rowStyles}>
                <div className={`${isMobile ? 'col-2' : 'col-3'} text-end`}>
                    <input type='checkbox'
                        className={'form-check-input checkbox-md pointer'}
                        checked={!!config.isEnabledHthDoubleState}
                        onChange={setIsEnabledHthDoubleStateHandler}
                    />
                </div>
                <div className={'col'}>
                    <h5 className={`${isDarkMode ? 'text-white' : ''} pt-2`}>
                        Habilitar doble estado de los timbres (atendió/no atendió)
                    </h5>
                </div>
            </div>
            <div className={'d-flex row justify-content-center align-items-center'} style={rowStyles}>
                <div className={`${isMobile ? 'col-2' : 'col-3'} text-end`}>
                    <input type='checkbox'
                        className={'form-check-input checkbox-md pointer'}
                        checked={!!config.isSharingHthAll}
                        onChange={setIsSharingAllHandler}
                    />
                </div>
                <div className={'col'}>
                    <h5 className={`${isDarkMode ? 'text-white' : ''} pt-2`}>
                        Liberar todos los territorios
                    </h5>
                </div>
            </div>
        </div>
    );
}
